import { form } from '../formState'
import { useTexts } from '../../hooks/useTexts'

export function OverrideTrackingSenderName() {
  const texts = useTexts()

  return (
    <form.Checkbox
      label={texts.overrideTrackingSenderName}
      validateOn="change"
      name="overrideTrackingSenderName"
      testId="overrideTrackingSenderName"
    />
  )
}
